import SwitchConfigView from '@/components/custom-controls/switch/SwitchConfigView.vue';
import SwitchControl from '@/components/custom-controls/switch/SwitchControl.vue';

import TextAreaCustomConfigView from '@/components/custom-controls/input/TextAreaCustomConfigView.vue';
import TextAreaCustomControl from '@/components/custom-controls/input/TextAreaCustomControl.vue';

export const switchControl = {
    name: 'Switch Field',
    description: 'Single Switch',

    /**
     * Control View Mapping
     */
    fieldComponent: SwitchControl,
    // fieldComponent: require('./switch/SwitchControl').default,

    /**
     * Control Configuration View Mapping
     */
    configComponent: SwitchConfigView,
    // configComponent: require('./switch/SwitchConfigView').default,

    /**
     * Control-Data Extend
     * Your specific data for your custom control
     */
    configData: {
        isChecked: false,
        switchColor: '#64bd63',
    },

    /**
     * Default data of the Switch in Renderer
     * @returns {boolean}
     */
    rendererDefaultData() {
        return false;
    },
};

export const datePickerControl = {
    name: 'Date Picker Control',
    description: 'Customized Date Picker Control',

    /**
     * Control View Mapping
     */
    fieldComponent: require('./date-picker/DatePickerControl').default,
    // fieldComponent: require('./switch/SwitchControl').default,

    /**
     * Control Configuration View Mapping
     */
    configComponent: require('./date-picker/DatePickerConfigView').default,
    // configComponent: require('./switch/SwitchConfigView').default,

    /**
     * Control-Data Extend
     * Your specific data for your custom control
     */
    configData: {
        disableByRoleSetting: false,
        format: 'DD/MM/YYYY',
        hasMask: true,
        mask: '##/##/####',
        singleMode: true, // date or date-range
        readOnly: true,
    },

    /**
     * Default data of the Switch in Renderer
     * @returns {boolean}
     */
    rendererDefaultData() {
        return null;
    },
};


export const fileUploadControl = {
    name: 'File Upload',
    description: 'File Upload',

    /**
     * Control View Mapping
     */
    fieldComponent: require('./file_upload/FileUploadControl').default,

    /**
     * Control Configuration View Mapping
     */
    configComponent: require('./file_upload/FileUploadConfigView').default,

    /**
     * Control-Data Extend
     * Your specific data for your custom control
     */
    configData: {
        maxSize: 1024,
        allowedExtension: 'application/pdf',
        disableByRoleSetting: false,
    },

    /**
     * Default data of the Switch in Renderer
     * @returns {boolean}
     */
    // rendererDefaultData() {
    //     return null;
    // },
};


export const dropdownControl = {
    name: 'Dropdown Custom Field',
    description: 'Dropdown Custom Field',

    /**
     * Control View Mapping
     */
    fieldComponent: require('./dropdown/DropdownControl').default,

    /**
     * Control Configuration View Mapping
     */
    configComponent: require('./dropdown/DropdownConfigView').default,

    /**
     * Control-Data Extend
     * Your specific data for your custom control
     */
    configData: {
        items: [],
        external_data_id: 0,
        field_text: 'Text',
        field_value: 'Value',
        field_hint: 'Hint',
        disableByRoleSetting: false,
    },

    /**
     * Default data of the Switch in Renderer
     * @returns {boolean}
     */
    // rendererDefaultData() {
    //     return null;
    // },
};


export const textFieldControl = {
    name: 'Text Field Custom',
    description: 'Text Field Custom',

    /**
     * Control View Mapping
     */
    fieldComponent: require('./input/TextFieldControl').default,

    /**
     * Control Configuration View Mapping
     */
    configComponent: require('./input/TextFieldConfigView').default,

    /**
     * Control-Data Extend
     * Your specific data for your custom control
     */
    configData: {
        default_value: '',
        hasMask: false,
        mask: null,
        hasDefaultValue: false,
        defaultValueKey: null,
        disableByRoleSetting: false,
    },

    /**
     * Default data of the Switch in Renderer
     * @returns {boolean}
     */
    // rendererDefaultData() {
    //     return null;
    // },
};

export const customTextArea = {
    name: 'Custom Text Area',
    description: 'Custom Text Area',

    fieldComponent: TextAreaCustomControl,
    configComponent: TextAreaCustomConfigView,

    configData: {
        rows: 3, // numeric]
        disableByRoleSetting: false,
    },
};
